const POPUP_RULES = [
    { match: "of_walkthrough", setter: "setShowOFWalkthroughCoach" },
    { match: "walkthrough", setter: "setShowMPWalkthroughCoach" },
    { match: "welcome", setter: "setShowWelcomeModal" },
    { match: "free_tools", setter: "setShowFreeToolsModal" },
    { match: "glossary", setter: "setShowGlossaryCoach" },
    { match: "user_manual", setter: "setShowUserManualMarketingPopup" },
];

/** Reads orient_popup off an MPCHART response and opens the matching popup, if any. */
export function applyOrientPopupFlags(responseData, handlers = {}) {
    const flag = responseData?.orient_popup?.trim().toLowerCase();
    const setter = POPUP_RULES.find((rule) => flag?.includes(rule.match))?.setter;
    if (!setter) return;

    POPUP_RULES.forEach((rule) => handlers[rule.setter]?.(false));
    handlers[setter]?.(true);
}
